<template>
  <div>
    <div class="reset-manager-submenu">
      <div :class="{'reset-manager-submenu-item':true,'selected':$route.query.submenu==='reset_ing'}" @click="gotoSubmenu('reset_ing',$event)">
        <div class="icon reset_ing">
          <img src="/img/reset/ico_sub_menu_reset_ing.png" :alt="$t('reset_manager.submenu.reset_ing')">
        </div>
        <div class="submenu-text">
          {{ $t('reset_manager.submenu.reset_ing') }}
        </div>
      </div>
      <div :class="{'reset-manager-submenu-item':true,'selected':$route.query.submenu==='my_reset'}" @click="gotoSubmenu('my_reset',$event)">
        <div class="icon my_reset">
          <img src="/img/reset/ico_sub_menu_my_reset.png" :alt="$t('reset_manager.submenu.reset_ing')">
        </div>
        <div class="submenu-text">
          {{ $t('reset_manager.submenu.my_reset') }}
        </div>
      </div>
      <div :class="{'reset-manager-submenu-item':true,'selected':$route.query.submenu==='reset_friends'}" @click="gotoSubmenu('reset_friends',$event)">
        <div class="icon reset_friends">
          <img src="/img/reset/ico_sub_menu_partner_reset.png" :alt="$t('reset_manager.submenu.reset_ing')">
        </div>
        <div class="submenu-text">
          {{ $t('reset_manager.submenu.reset_friends') }}
        </div>
      </div>
      <div :class="{'reset-manager-submenu-item':true,'selected':$route.query.submenu==='reset_share'}" @click="gotoSubmenu('reset_share',$event)">
        <div class="icon reset_share">
          <img src="/img/reset/ico_sub_menu_reset_share.png" :alt="$t('reset_manager.submenu.reset_ing')">
        </div>
        <div class="submenu-text">
          {{ $t('reset_manager.submenu.reset_share') }}
        </div>
      </div>
      <div :class="{'reset-manager-submenu-item':true,'selected':$route.query.submenu==='reset_friends_management'}" @click="gotoSubmenu('reset_friends_management',$event)">
        <div class="icon reset_friends_management">
          <img src="/img/reset/ico_sub_menu_reset_friends.png" :alt="$t('reset_manager.submenu.reset_ing')">
        </div>
        <div class="submenu-text">
          {{ $t('reset_manager.submenu.reset_friends_management') }}
        </div>
      </div>
    </div>
    <div class="clear" />
    <div class="reset-contents">
      <div v-if="$route.query.submenu==='reset_ing'">
        <div v-if="$route.query.mode==='calendar'">
          <div class="reset-calendar">
            <div class="reset-calendar-buttons">
              <div class="reset-calendar-button new-button" @click="setMode('create', $event)">
                {{ $t('reset.button.new') }}
              </div>
              <div class="reset-calendar-button edit-button" @click="setMode('update', $event)">
                {{ $t('reset.button.edit') }}
              </div>
              <div class="reset-calendar-button share-button" @click="setMode('transfer', $event)">
                {{ $t('reset.button.share') }}
              </div>
              <div class="reset-calendar-button refresh-button" @click="initConfirm($event)">
                {{ $t('reset.button.init') }}
              </div>
            </div>
            <div class="clear" />
            <calendar
              ref="calendarRef"
              v-model="resets"
              class="reset-ing-calendar"
              :day-selectable="true"
              :emit-day-event-on-click="true"
              :show-period-text="true"
              @period-selected="onPeriodSelected"
              @month-changed="onMonthChanged"
              @day-selected="onDaySelected"
            />
            <div class="clear" />
          </div>
          <div class="clear" />
          <div v-if="selectedReset" class="reset-graph-container">
            <div class="goal-area">
              <div class="goal-body-weight">
                <div class="dot" />
                <div class="label font-extra-bold">
                  {{ $t('reset_manager.label.weight') }}
                </div>
                <div class="text font-extra-bold">
                  {{ selectedReset.goalBdwgh }}kg
                </div>
              </div>

              <div class="goal-body-fat">
                <div class="dot" />
                <div class="label font-extra-bold">
                  {{ $t('reset_manager.label.fat') }}
                </div>
                <div class="text font-extra-bold">
                  {{ selectedReset.goalBodyFatRate }}%
                </div>
              </div>
            </div>
            <div class="reset-graph-wrapper">
              <div v-if="graphData" class="reset-graph" :style="{ width: graphWidth }">
                <line-chart :chart-data="getChartData(selectedReset)" :options="graphOptions" />
              </div>
              <div v-else class="reset-graph">
                {{ $t('reset_manager.text.no_data') }}
              </div>
            </div>
          </div>
          <div v-else class="no-reset-selected">
            {{ $t('reset_manager.text.no_selected_reset') }}
          </div>
        </div>
        <div v-if="$route.query.mode==='create'">
          <reset-editor v-model="newReset" @saved="onSaved" />
        </div>
        <div v-else-if="$route.query.mode==='update'">
          <reset-editor v-model="selectedReset" @saved="onSaved" />
        </div>
        <div v-else-if="$route.query.mode==='transfer'">
          <reset-editor v-model="newReset" :shared="true" @saved="onSaved" />
        </div>
        <div v-else-if="$route.query.mode==='detail'">
          <reset-hist :init-reset="selectedReset" :day="selectedDay" @to-list="setMode('calendar')" />
        </div>
      </div>
      <div v-else-if="$route.query.submenu==='my_reset'">
        <saved-reset-list
          v-if="!$route.query.savedId"
          key="my-reset-list"
          :init-data="savedResetsInitData"
          :init-conditions="savedConditions"
          @select-reset="onSelectReset"
          @condition-changed="onSavedConditionChanged"
          @scroll-and-data="onSavedResetScrollAndDataChanged"
        />
        <reset-detail v-else :id="$route.query.savedId" :key="'saved-reset-' + $route.query.savedId" />
      </div>
      <div v-else-if="$route.query.submenu==='reset_friends'">
        <shared-reset-list
          v-if="!$route.query.savedId"
          key="friends-reset-list"
          :init-conditions="sharedConditions1"
          :init-data="sharedResetsFriendsInitData"
          :show-only-friends="true"
          @select-reset="onSelectReset"
          @condition-changed="onSharedCondition1Changed"
          @scroll-and-data="onSharedResetFriendsScrollAndDataChanged"
        />
        <reset-detail v-else :id="$route.query.savedId" :key="'friends-shared-reset-' + $route.query.savedId" :shared="true" :show-only-friends="true" />
      </div>
      <div v-else-if="$route.query.submenu==='reset_share'">
        <shared-reset-list
          v-if="!$route.query.savedId"
          key="shared-reset-list"
          :init-data="sharedResetsInitData"
          :init-conditions="sharedConditions2"
          @select-reset="onSelectReset"
          @condition-changed="onSharedCondition2Changed"
          @scroll-and-data="onSharedResetScrollAndDataChanged"
        />
        <reset-detail v-else :id="$route.query.savedId" :key="'shared-reset-' + $route.query.savedId" :shared="true" />
      </div>
      <div v-else-if="$route.query.submenu==='reset_friends_management'">
        <reset-friend-list />
      </div>
      <div class="clear" />
    </div>
    <b-modal
      id="init-confirm-modal"
      ref="initConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      centered
      :no-close-on-backdrop="true"
      @ok="initReset($event)"
    >
      <p class="my-4" v-html="$t('reset.confirm.init')" />
    </b-modal>
  </div>
</template>

<script>
import ResetEditor from '../composites/ResetEditor'
import ResetHist from '../composites/ResetHist'
import SavedResetList from '../composites/SavedResetList'
import SharedResetList from '../composites/SharedResetList'
import ResetDetail from '../composites/ResetDetail'
import ResetFriendList from '../composites/ResetFriendList'

const chartDrawCustom = function() {
  const ctx = this.chart.ctx
  ctx.font = 'normal 0.8rem NanumSquareRoundB'
  ctx.fillStyle = '#707070'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'bottom'

  this.data.datasets.forEach(function(dataset) {
    for (let i = 0; i < dataset.data.length; i++) {
      for (const key in dataset._meta) {
        const model = dataset._meta[key].data[i]._model
        ctx.fillText(dataset.data[i] + dataset.postfix, model.x, model.y + 20)
      }
    }
  })
}

export default {
  components: {
    ResetHist,
    ResetEditor,
    SavedResetList,
    ResetDetail,
    SharedResetList,
    ResetFriendList
  },
  data() {
    if (!this.minValue) {
      this.minValue = 0
    }
    if (!this.maxValue) {
      this.maxValue = 100
    }
    return {
      newReset: {},
      savedResetsInitData: undefined,
      sharedResetsInitData: undefined,
      sharedResetsFriendsInitData: undefined,
      graphData: undefined,
      graphOptions: {
        maintainAspectRatio: false,
        animation: {
          duration: 0,
          onComplete: chartDrawCustom,
          onProgress: chartDrawCustom
        },
        legend: {
          display: false,
          position: 'bottom'
        },
        layout: {
          padding: {
            left: 5,
            top: 10,
            right: 20,
            bottom: 0
          }
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                display: false,
                color: '#dddddd',
                drawBorder: false,
                zeroLineColor: '#ffffff',
                zeroLineWidth: 0
              },
              ticks: {
                min: this.minValue,
                max: this.maxValue,
                callback: function(value, index, values) {
                  return ' '
                }
              },
              drawBorder: false
            }
          ]
        }
      },
      resets: [],
      selectedReset: undefined,
      selectedDay: undefined,
      dateformat: this.$t('common.format.date'),
      products: undefined,
      showSelected: false,
      graphWidth: '100vw',
      sharedConditions1: undefined,
      sharedConditions2: undefined,
      savedConditions: undefined
    }
  },
  watch: {
    '$route.query.mode': {
      handler(newVal, oldVal) {
        if (newVal) {
          $('body').attr('mode', newVal)
        } else {
          $('body').removeAttr('mode')
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (!this.$route.query.submenu) {
      this.gotoSubmenu('reset_ing', undefined, true)
    }
    this.$eventHub.$emit('content-loaded')
  },
  beforeDestroy() {
    $('body').removeAttr('mode')
  },
  methods: {
    onSharedResetScrollAndDataChanged(data) {
      this.sharedResetsInitData = data
    },
    onSharedResetFriendsScrollAndDataChanged(data) {
      this.sharedResetsFriendsInitData = data
    },
    onSavedResetScrollAndDataChanged(data) {
      this.savedResetsInitData = data
    },
    onSavedConditionChanged(param) {
      this.savedConditions = param
      this.$forceUpdate()
    },
    onSharedCondition1Changed(param) {
      this.sharedConditions1 = param
      this.$forceUpdate()
    },
    onSharedCondition2Changed(param) {
      this.sharedConditions2 = param
      this.$forceUpdate()
    },
    onSaved() {
      this.resetListRequestId = 0
      this.savedResetsInitData = undefined
    },
    onSelectReset(param) {
      const e = param.e
      const reset = param.reset
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!reset) {
        return
      }
      const query = window.copyObject(this.$route.query)
      query.savedId = reset.id
      this.$router.push({
        query: query
      })
    },
    initConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!this.selectedReset) {
        this.$toast.info(this.$t('reset.notification.no_selected'))
        return
      }
      this.showModal('initConfirmModalRef')
    },
    initReset(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!this.selectedReset) {
        this.$toast.info(this.$t('reset.notification.no_selected'))
        this.hideModal('initConfirmModalRef')
        return
      }
      this.$axios
        .$put('/reset/init?id=' + this.selectedReset.id)
        .then(response => {
          if (response.resultCode === 'success') {
            this.hideModal('initConfirmModalRef')
            this.onMonthChanged(this.currentMonth)
            this.$toast.info(this.$t(response.message))
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
    },
    setMode(mode, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (mode === 'transfer' && this.isCouponUser()) {
        this.$toast.info(this.$t('reset.text.coupon_user_cannot_share'))
        return
      }
      if (!this.selectedReset && mode === 'update') {
        this.$toast.info(this.$t('reset.notification.no_selected'))
        return
      }
      const query = {}
      for (const key in this.$route.query) {
        query[key] = this.$route.query[key]
      }
      query.mode = mode
      if (mode === 'create' || mode === 'update' || mode === 'transfer') {
        query.step = '1'
        this.newReset = {}
      }
      this.$router.push({
        query: query
      })
      this.$forceUpdate()
    },
    getChartData(reset) {
      const ret = {
        datasets: [
          {
            label: this.$t('reset_manager.label.weight'),
            borderColor: '#015b97',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            postfix: 'kg'
          },
          {
            label: this.$t('reset_manager.label.fat'),
            borderColor: '#03ccc8',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            postfix: '%'
          }
        ],
        datalabels: {
          align: 'start',
          anchor: 'start'
        }
      }

      if (!reset.hists) {
        reset.hists = []
      }
      const weights = []
      const fats = []
      const bgndeDt = this.$moment(reset.bgnde, this.dateformat).toDate()
      const enddeDt = this.$moment(reset.endde, this.dateformat).toDate()
      const days =
        1 + (enddeDt.getTime() - bgndeDt.getTime()) / (24 * 60 * 60 * 1000)
      let lastBdwgh
      let lastBodyFatRate
      const labels = []
      let haveFound = false
      labels.push(this.$t('reset.graph.begin'))
      weights.push(reset.bgnBdwgh)
      fats.push(reset.bgnBodyFatRate)
      for (let i = 0; i < days; i++) {
        let found = false
        let willFind = false
        const dt = new Date(i * 24 * 60 * 60 * 1000 + bgndeDt.getTime())
        const dtStr = this.$moment(dt).format(this.$t('common.format.date'))
        labels.push(this.$t('reset.graph.day', { no: i + 1 }))
        for (let l = 0; l < reset.hists.length; l++) {
          if (reset.hists[l].de > dtStr) {
            willFind = true
            break
          }
        }
        for (let j = 0; j < reset.hists.length; j++) {
          if (dtStr === reset.hists[j].de) {
            if (!haveFound) {
              haveFound = true
              for (let k = 0; k < weights.length; k++) {
                weights[k] = reset.hists[j].bdwgh
                fats[k] = reset.hists[j].bodyFatRate
              }
            }
            weights.push(reset.hists[j].bdwgh)
            fats.push(reset.hists[j].bodyFatRate)
            lastBdwgh = reset.hists[j].bdwgh
            lastBodyFatRate = reset.hists[j].bodyFatRate
            found = true
            break
          }
        }
        if (!found) {
          if (lastBdwgh !== undefined && lastBodyFatRate !== undefined) {
            if (willFind) {
              weights.push(lastBdwgh)
              fats.push(lastBodyFatRate)
            } else {
              weights.push(null)
              fats.push(null)
            }
          } else {
            weights.push(0)
            fats.push(0)
          }
        }
      }
      labels.push(this.$t('reset.graph.result'))
      weights.push(reset.resultBdwgh)
      fats.push(reset.resultBodyFatRate)
      labels.push(this.$t('reset.graph.goal'))
      weights.push(reset.goalBdwgh)
      fats.push(reset.goalBodyFatRate)

      ret.datasets[0].data = weights
      ret.datasets[1].data = fats
      ret.labels = labels
      this.minValue = 1000000
      this.maxValue = -1000000
      for (let i = 0; i < weights.length; i++) {
        if (weights[i] - 10 < this.minValue) {
          this.minValue = weights[i] - 10
        }
        if (fats[i] - 20 < this.minValue) {
          this.minValue = fats[i] - 20
        }
        if (weights[i] + 10 > this.maxValue) {
          this.maxValue = weights[i] + 10
        }
        if (fats[i] + 20 > this.maxValue) {
          this.maxValue = fats[i] + 20
        }
      }
      if (!haveFound) {
        return undefined
      }
      return ret
    },
    gotoSubmenu(submenu, e, replace) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (!this.$route.query || this.$route.query.submenu !== submenu) {
        let url = this.$route.path + '?submenu=' + submenu
        if (submenu === 'reset_ing') {
          url += '&mode=calendar'
        }
        if (replace) {
          this.$router.replace(url)
        } else {
          this.$router.push(url)
        }
        this.vibrate(e)
      }
    },
    onDaySelected(param) {
      if (!this.selectedReset) {
        this.$toast.info(this.$t('reset.notification.no_selected'))
        return
      }
      this.selectedDay = param
      this.setMode('detail')
    },
    onPeriodSelected(param) {
      this.selectedReset = param
      this.graphData = undefined
      if (param) {
        this.$nextTick(() => {
          this.graphData = this.getChartData(param)
          this.graphWidth = '100vw'
          if (
            this.graphData &&
            this.graphData.labels &&
            this.graphData.labels.length > 5
          ) {
            this.graphWidth = (100 * this.graphData.labels.length) / 7
            this.graphWidth += 'vw'
          }
        })
      }
      this.$forceUpdate()
    },
    onMonthChanged(param) {
      this.currentMonth = param
      let beginDt = param.year + '/'
      if (param.month + 1 < 10) {
        beginDt += '0'
      }
      beginDt = beginDt + (param.month + 1) + '/01'

      if (!this.resetListRequestId) {
        this.resetListRequestId = 0
      }
      this.resetListRequestId++
      const endTime = new Date()
      endTime.setFullYear(param.year)
      endTime.setMonth(
        this.resetListRequestId === 1 ? param.month + 2 : param.month + 1
      )
      endTime.setDate(0)

      let endDt = endTime.getFullYear() + '/'
      if (endTime.getMonth() + 1 < 10) {
        endDt += '0'
      }
      endDt = endDt + (endTime.getMonth() + 1) + '/31'

      const url =
        '/reset/myresets?currentOnlyFlag=N&beginDt=' +
        encodeURIComponent(beginDt) +
        '&endDt=' +
        encodeURIComponent(endDt)
      this.$axios.$get(url).then(response => {
        if (response.resultCode === 'success') {
          if (response.data) {
            this.resets = response.data
          } else {
            this.resets = []
          }
          if (this.resetListRequestId === 1) {
            this.setResetAlarms(this.resets)
          }
          this.$nextTick(() => {
            if (this.$refs.calendarRef) {
              this.$refs.calendarRef.initSelected()
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.reset-manager-submenu {
  padding: 0.4rem 1.083333333333333rem 0.6rem;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  position: fixed;
  width: 100vw;
  top: 6.8rem;
  z-index: 5;
  padding-top: 1.125rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
}
.reset-manager-submenu-item {
  float: left;
  font-size: 1.05rem !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.reset-manager-submenu-item .icon {
  width: 3.916rem;
  height: 3.916rem;
  background-color: #d5d5d5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reset-manager-submenu-item .icon.reset_ing img {
  width: 1.9833333rem;
  height: 2.208333333333333rem;
}
.reset-manager-submenu-item .icon.my_reset img {
  width: 2.358333333333333rem;
  height: 2.608333333333333rem;
}
.reset-manager-submenu-item .icon.reset_friends img {
  width: 2.066666666666667rem;
  height: 1.566666666666667rem;
}
.reset-manager-submenu-item .icon.reset_share img {
  width: 1.708333333333333rem;
  height: 1.708333333333333rem;
}
.reset-manager-submenu-item .icon.reset_friends_management img {
  width: 2.108333333333333rem;
  height: 2.15rem;
}

.reset-manager-submenu-item.selected .icon {
  background-color: #360ea6;
}
.reset-manager-submenu-item .submenu-text {
  border-radius: 1rem;
  padding: 0 0.5rem;
  min-width: 90%;
  text-align: center;
  height: 1.7rem;
  white-space: nowrap;
  line-height: 1.7rem;
  display: flex;
  font-size: 0.83333rem;
  align-items: center;
  color: #d5d5d5;
}
.reset-manager-submenu-item.selected .submenu-text {
  color: #360ea6;
  font-weight: bold;
}
.reset-contents {
  padding-top: 7rem;
}
.reset-ing-calendar {
  margin-top: 1rem;
}
.reset-calendar {
  background-repeat: no-repeat;
  background-size: 100vw;
  background-position: 0 -1.8rem;
  background-attachment: fixed;
  color: black;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  padding-top: 0.6rem;
}
.reset-calendar-button {
  padding-bottom: 0.3rem;
  font-size: 0.916666666666667rem;
  height: 3.125rem;
  display: flex;
  align-items: center;
  width: 25vw;
  justify-content: center;
}
.reset-calendar-button:focus,
.reset-calendar-button:active,
.reset-calendar-button:hover {
  border-bottom: 2px solid #360ea6;
}
.reset-calendar-button.new-button img {
  width: 1.54rem;
}
.reset-calendar-button.edit-button img {
  margin-left: 1.108rem;
  width: 1.4rem;
}
.reset-calendar-button.share-button img {
  width: 1.31rem;
  margin-left: 1.125rem;
}
.reset-calendar-button.refresh-button img {
  width: 2.06rem;
  margin-left: 1.108rem;
}
.reset-calendar-buttons {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
}
.no-reset-selected {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vw;
}
.reset-graph-container {
  background: #ededed;
}
.reset-graph-wrapper {
  overflow-x: auto;
}
.reset-graph {
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vw;
}
.reset-graph > div {
  position: relative;
  width: 100%;
  height: 50vw;
}
.goal-area {
  display: flex;
  padding: 0.358rem;
  justify-content: center;
  align-items: center;
}
.goal-area > div {
  width: 50%;
  font-size: 0.833333rem;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.25rem 1rem;
}
.goal-area .text {
  font-size: 1rem;
}
.goal-area .goal-body-fat .dot,
.goal-area .goal-body-weight .dot {
  width: 0.56rem;
  height: 0.56rem;
  border-radius: 0.28rem;
  margin-top: 0.3rem;
}
.goal-area .goal-body-weight {
  border-right: 2px solid #dfdfdf;
}
.goal-area .goal-body-weight .dot {
  background-color: #360ea6;
}
.goal-area .goal-body-fat .dot {
  background-color: #03ccc8;
}
.goal-area .goal-body-weight .label {
  color: #360ea6;
}
.goal-area .goal-body-fat .label {
  color: #03ccc8;
}
.goal-area .label {
  font-weight: normal;
  letter-spacing: 0.04rem !important;
  font-size: 0.8833rem;
}
.goal-area .goal-body-weight > div,
.goal-area .goal-body-fat > div {
  float: left;
}
</style>
